import React from 'react';
import { useFormContext } from 'react-hook-form';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { TextBox, When } from 'UI/components/atoms';

import { COPIES, FORM_FIELDS_MAP, SENDOVER_REASONS } from './SendoverReasonsFields.constants';
import { VerticalStack } from './SendoverReasonsFields.styled';

export const SendoverReasonsFields = () => {
  const { errors, register } = useFormContext();

  const hasError = Boolean(errors[FORM_FIELDS_MAP.SendoverReasons.key]);

  return (
    <VerticalStack>
      <Typography variant="body2">{COPIES.subtitle}</Typography>

      <FormControl component="fieldset" error={hasError}>
        <FormGroup>
          {SENDOVER_REASONS.map(reason => (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  name={FORM_FIELDS_MAP.SendoverReasons.key}
                  value={reason}
                  inputRef={register({
                    validate: value =>
                      (Array.isArray(value) && value.length > 0) || COPIES.errors.reasons
                  })}
                />
              }
              key={reason}
              label={reason}
            />
          ))}

          <When condition={hasError}>
            <FormHelperText>{errors[FORM_FIELDS_MAP.SendoverReasons.key]?.message}</FormHelperText>
          </When>
        </FormGroup>
      </FormControl>

      <TextBox
        inputRef={register()}
        label={COPIES.labels.comments}
        multiline
        name={FORM_FIELDS_MAP.Comments.key}
        placeholder={COPIES.labels.comments}
      />
    </VerticalStack>
  );
};
